import classNames from 'classnames';
import { memo } from 'react';

export type ProgressDashesProps = {
  totalSteps: number;
  currentStep: number;
};

export const ProgressDashes = memo(({ totalSteps, currentStep }: ProgressDashesProps) => {
  return (
    <div className="flex gap-2 px-4 py-2">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div
          key={index}
          className={classNames(
            'h-1 w-8 rounded-full transition-colors duration-300 ease-out',
            index <= currentStep ? 'bg-blue-9' : 'bg-grey-4',
          )}
        />
      ))}
    </div>
  );
});

ProgressDashes.displayName = 'ProgressDashes';
